import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {SlugData, UserInterfaces, UserNavigationLinkItems, UserNavigationLinks} from '../interfaces/user.interfaces';
import {map, Observable, of} from 'rxjs';
import {IframePage} from '../interfaces/iframe-page.interfaces';
import {UserPage} from '../interfaces/user-pages.interfaces';
import {NavigationLinks} from '../interfaces/navigation-links.interfaces';
import {ReorderInterface} from '../comon/table/table.component';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private http: HttpClient) { }

  getUser(): Observable<UserInterfaces> {
    return this.http.get<UserInterfaces>('/api/users');
  }

  getUsers(): Observable<{ items: UserInterfaces[], totalCount: number }> {
    return this.http.get<{ items: UserInterfaces[], totalCount: number }>('/api/management/users');
  }

  addUserGroup(params: { userId: string, navigationLinkGroupIds: string[] }) {
    return this.http.post('/api/management/user-navigation-link-groups', params)
  }

  updateUserGroup(params: { userId: string, navigationLinkGroupIds: string[] }) {
    return this.http.post('/api/management/user-navigation-link-groups', params)
  }

  deleteUserGroup(userNavigationLinkGroupId: string) {
    return this.http.delete(`/api/management/user-navigation-link-groups/${userNavigationLinkGroupId}`)
  }

  getUserNavigation() {
    return this.http.get<{ items: UserNavigationLinks[], totalCount: number }>('/api/navigation-link-groups').pipe(
      map(el => {
        el.items = el.items.map((item) => {
          return {...item, navigationLinks: {items: (item.navigationLinks as unknown as UserNavigationLinkItems[])?.map(el => ({ ...el, icon: (el.isSlug && el.link) ? '' : 'pi pi-external-link'}))}}
        }) as UserNavigationLinkItems[];
        return el;
      }),
    )
  }

  getUserPage(params: {page: number, pageCount: number, navigationLinkGroupId: string, userId: string }): Observable<{ items: UserPage[], totalCount: number}> {
    return this.http.get<{ items: UserPage[], totalCount: number }>(
      '/api/management/user-navigation-link-groups',
      { params: params }
    ).pipe(
      map((el) => ({items: el.items.map((item) => ({...item, id: item.userId})), totalCount: el.totalCount}))
    );
  }

  getLinkById(userId: string) {
    return this.http.get<{ items: UserNavigationLinkItems[], totalCount: number }>(`/api/management/user-navigation-link-groups/${userId} `).pipe(
      map((el) => ({items: el.items.map((item) => ({...item, navigationLinkGroupId: item.navigationLinkGroup?.id, navigationLinkGroupName: item.navigationLinkGroup?.name})), totalCount: el.totalCount}))
    )
  }

  getGroups(ExcludeGroupUserId: string, nameStartsWith = ''): Observable<{ items: NavigationLinks[]}> {
    return this.http.get<{ items: NavigationLinks[] }>(`/api/management/navigation-link-groups/$suggestions`, { params: { nameStartsWith, ExcludeGroupUserId }});
  }

  reorderLinks(navigationLinkGroupId: string, data: { beforeId?: string; afterId?: string}): Observable<void> {
    return this.http.patch<void>(`/api/management/user-navigation-link-groups/${navigationLinkGroupId}`, data);
  }
}
